import PropTypes from "prop-types"

import { cn } from "styles/utils"

export const SectionTitle = ({ as, className = "", ...props }) => {
  const Comp = as ?? "h2"
  return (
    <Comp
      className={cn(
        "text-neutral text-16 tablet:tracking-widest mb-16 tracking-wide",
        className
      )}
      {...props}
    />
  )
}
SectionTitle.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
}
export default SectionTitle
